import { StringParam, withDefault } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';

export const columnsItems = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'orderId',
    label: 'Order ID',
    sortable: false,
  },
  {
    name: 'createdAt',
    label: 'Creation Date',
    sortable: true,
  },
  {
    name: 'orderDate',
    label: 'Order date',
    sortable: false,
  },
  {
    name: 'paymentOrderId',
    label: 'Payment Order ID',
    sortable: false,
  },
  {
    name: 'orderStatus',
    label: 'Payment Order Status',
    sortable: false,
  },
  {
    name: 'orderCreatedAt',
    label: 'Payment Order Created',
    sortable: false,
  },
  {
    name: 'orderAcceptedAt',
    label: 'Payment Order Accepted',
    sortable: false,
  },
  {
    name: 'senderId',
    label: 'Sender ID',
    sortable: false,
  },
  {
    name: 'senderName',
    label: 'Sender Name',
    sortable: false,
  },
  {
    name: 'senderAddress',
    label: 'Sender Address',
    sortable: false,
  },
  {
    name: 'senderDob',
    label: 'Sender DOB',
    sortable: false,
  },
  {
    name: 'localCountryId',
    label: 'Local Country',
    sortable: false,
  },
  {
    name: 'localCurrencyId',
    label: 'Local Currency',
    sortable: false,
  },
  {
    name: 'localAmount',
    label: 'Local Amount',
    sortable: false,
  },
  {
    name: 'destCountryId',
    label: 'Destination Country',
    sortable: false,
  },
  {
    name: 'destCurrencyId',
    label: 'Destenation Currency',
    sortable: false,
  },
  {
    name: 'destAmount',
    label: 'Destenation Amount',
    sortable: false,
  },
  {
    name: 'recepientAccountId',
    label: 'Beneficiary Company',
    sortable: false,
  },
  {
    name: 'beneficiaryName',
    label: 'Beneficiary Name',
    sortable: false,
  },
  {
    name: 'beneficiaryCity',
    label: 'Payout Location',
    sortable: false,
    filterModalPlacement: 'right',
  },
];

export const columnsLabels = {
  orderId: 'Order ID',
  senderId: 'Sender ID',
  createdAt: 'Creation Date',
  createdAtFrom: 'Creation Date From',
  createdAtTo: 'Creation Date To',
  localCountryId: 'Local Country',
  localCurrencyId: 'Local Currency',
  destCountryId: 'Destionation Country',
  destCurrencyId: 'Destination Currency',
  paymentOrderId: 'Payment Order ID',
  orderStatus: 'Payment Order Status',
  orderCreatedAt: 'Payment Order Created',
  orderCreatedAtFrom: 'Payment Order Created From',
  orderCreatedAtTo: 'Payment Order Created To',
  orderAcceptedAt: 'Payment Order Accepted',
  orderAcceptedAtFrom: 'Payment Order Accepted From',
  orderAcceptedAtTo: 'Payment Order Accepted To',
  senderName: 'Sender Name',
  senderAddress: 'Sender Address',
  senderDob: 'Sender DOB',
  localAmount: 'Local Amount',
  destAmount: 'Destionation Amount',
  beneficiaryName: 'Beneficiary Name',
  beneficiaryCity: 'Beneficiary City',
  recepientAccountId: 'Beneficiary Company',
};

export const defaultSorter = {
  sortProp: columnsItems[2].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  createdAt: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['createdAtFrom', 'createdAtTo'],
  },
  createdAtFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  createdAtTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  orderCreatedAt: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['orderCreatedAtFrom', 'orderCreatedAtTo'],
  },
  orderCreatedAtFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  orderCreatedAtTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  orderAcceptedAt: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['orderAcceptedAtFrom', 'orderAcceptedAtTo'],
  },
  orderAcceptedAtFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  orderAcceptedAtTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  orderId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  senderId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  localCountryId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  localCurrencyId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  destCountryId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  destCurrencyId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  paymentOrderId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  orderStatus: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  senderName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  senderAddress: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  senderDob: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE,
  },
  localAmount: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  destAmount: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  beneficiaryName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  beneficiaryCity: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  recepientAccountId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'orderId',
    type: FilterType.TEXT,
    placeholder: 'Enter Order ID...',
  },
  {
    name: 'senderId',
    type: FilterType.TEXT,
    placeholder: 'Enter Sender ID...',
  },
  {
    name: 'localCountryId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Select Country...',
  },
  {
    name: 'localCurrencyId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Select currency...',
  },
  {
    name: 'destCountryId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Select Country...',
  },
  {
    name: 'destCurrencyId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Select currency...',
  },
  {
    name: 'paymentOrderId',
    type: FilterType.TEXT,
    placeholder: 'Enter Payment Order ID...',
  },
  {
    name: 'orderStatus',
    type: FilterType.CHECKBOX,
    withClearButton: true,
    fields: [
      {
        name: 'status',
        title: 'Pending Review',
        value: 'QUEUED',
      },
      {
        name: 'status',
        title: 'Accepted',
        value: 'ACCEPTED',
      },
      {
        name: 'status',
        title: 'AML',
        value: 'AML',
      },
      {
        name: 'status',
        title: 'AML Done',
        value: 'AML_DONE',
      },
      {
        name: 'status',
        title: 'Proc',
        value: 'PROC',
      },
      {
        name: 'status',
        title: 'Rejected',
        value: 'REJECTED',
      },
      {
        name: 'status',
        title: 'AML Rejected',
        value: 'AML_REJ',
      },
    ],
  },
  {
    name: 'orderCreatedAt',
    type: FilterType.DATE_RANGE,
    pickerType: 'twoPickers',
    withoutCustomSelector: true,
  },
  {
    name: 'orderAcceptedAt',
    type: FilterType.DATE_RANGE,
    pickerType: 'twoPickers',
    withoutCustomSelector: true,
  },
  {
    name: 'createdAt',
    type: FilterType.DATE_RANGE,
    pickerType: 'twoPickers',
    withoutCustomSelector: true,
  },
  {
    name: 'senderName',
    type: FilterType.TEXT,
    placeholder: 'Enter Sender Name...',
  },
  {
    name: 'senderAddress',
    type: FilterType.TEXT,
    placeholder: 'Enter Sender Address...',
  },
  {
    name: 'senderDob',
    type: FilterType.DATE,
  },
  {
    name: 'localAmount',
    type: FilterType.TEXT,
    placeholder: 'Enter Amount...',
  },
  {
    name: 'destAmount',
    type: FilterType.TEXT,
    placeholder: 'Enter Amount...',
  },
  {
    name: 'beneficiaryName',
    type: FilterType.TEXT,
    placeholder: 'Enter Name...',
  },
  {
    name: 'beneficiaryCity',
    type: FilterType.TEXT,
    placeholder: 'Enter City...',
  },
  {
    name: 'recepientAccountId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by account...',
  },
];
